import { useContext } from "react";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { convertToJalali, formatGregorianDate, formatPersianDate } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";
import { LocaleContext } from "../../../../routing/LangRouter";

//import images and icons
import hotelImage from "../../../../assets/imgs/room-image.png";

export function AccommodationOrderContent({ orderItem }) {
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: "numeric",
            weekday: undefined,
        });
    };

    return (
        <Grid container item xs={12} columnGap={2}>
            {orderItem?.accommodation?.is_foreign ? (
                <img className="orders__hotel-image" src={orderItem?.accommodation?.image?.image || hotelImage} />
            ) : (
                <img className="orders__hotel-image" src={"https://api.atripa.ir" + orderItem?.accommodation?.image?.image || hotelImage} />
            )}

            <Grid container item xs={9} md={10} rowGap={{ xs: 0, md: 1 }}>
                <Grid className="orders__airline-name" component="span" container item xs={12}>
                    {orderItem?.accommodation?.accommodation?.name || orderItem?.accommodation?.accommodation?.english_name}
                </Grid>

                <Grid className="orders__destination" component="span" container item xs={12}>
                    <div className="orders__point"></div>
                    {orderItem?.accommodation?.accommodation?.city}
                </Grid>

                <Grid container item xs={12} columnGap={1}>
                    <Grid container display={{ xs: "none", md: "flex" }}>
                        {t("Hotel.Stay Date")}:
                    </Grid>
                    <span className="orders__date-time">
                        {locale === "fa"
                            ? formatDate(orderItem?.accommodation?.check_in) + " - " + formatDate(orderItem?.accommodation?.check_out)
                            : formatGregorianDate(orderItem?.accommodation?.check_in, null, "YYYY/MM/DD") +
                              " - " +
                              formatGregorianDate(orderItem?.accommodation?.check_out, null, "YYYY/MM/DD")}
                    </span>
                </Grid>
            </Grid>
        </Grid>
    );
}

function AccommodationOrders({ orderItem, handleClick }) {
    const { t } = useTranslation();
    return (
        <Grid
            className="orders__order-item"
            container
            item
            xs={12}
            rowGap={2}
            alignItems="flex-start"
            onClick={() => handleClick("accommodation", orderItem.accommodation?.is_foreign, orderItem)}
        >
            <Grid container item xs={12} columnGap={1} alignItems="center">
                <span className={`orders__label orders__label--${orderItem?.get_status?.en}`}>{orderItem?.get_status?.fa}</span>
                <span className="orders__label orders__label--date">
                    {t("General.Order Date")}: {convertToJalali(orderItem?.create_date)}
                </span>
                <span className="orders__label orders__label--tracking-code">
                    {t("trackingCode")}: {orderItem?.tracking_code}
                </span>
            </Grid>

            <AccommodationOrderContent orderItem={orderItem} />

            <Divider width="100%" />

            <Grid container item xs={12} justifyContent="flex-end" alignItems="center">
                <span className="orders__order-price">
                    {t("amount")}: {numberWithCommas(orderItem?.accommodation?.total_price)}
                </span>
            </Grid>
        </Grid>
    );
}

export default AccommodationOrders;
